<template>
  <ContainerScrolling class="PrivacyInformation">
    <LayoutFill :no-gutters="!bannerGutter" :no-padding="!bannerGutter">
      <MainBanner :title="pageTitle" :solid-header="solidHeader" />
    </LayoutFill>
    <LayoutGutters>
      <LegalTerms term="PRIVACY" />
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";

import MainBanner from "~/components/banner/MainBanner";

import LegalTerms from "~/components/page/components/terms/LegalTerms";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "PrivacyInformation",
  components: {
    LegalTerms,
    ContainerScrolling,
    LayoutGutters,
    LayoutFill,
    MainBanner,
  },
  middleware: ["ensureUserLoaded"],
  data() {
    return {
      pageTitle: "Privacy Policy",
    };
  },
  head() {
    const { siteName } = this;

    const title = getPageTitle(siteName);
    const pageTitle = "Privacy Information | " + title;
    const cupTechText =
      this.partner === "chemrxiv"
        ? "technology provided by"
        : "brought to you by";

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `Privacy policy for ${siteName}, ${cupTechText} Cambridge University Press.   `,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      siteName: (state) => getSiteName(state.theme),
      layout: (state) => state.theme.layout,
    }),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    bannerGutter() {
      return this.layout.staticBannerGuttering;
    },
  },
};
</script>
